/**
 * GuestBuildingHeader Component
 * Displays building name, address, and navigation link
 */
import React from 'react';
import { Card } from 'react-bootstrap';
import { Building, MapPin, Navigation } from 'lucide-react';
import { BuildingContext } from '../../../types/guestAccess';

interface GuestBuildingHeaderProps {
    building: BuildingContext;
    projectTitle: string;
}

const GuestBuildingHeader: React.FC<GuestBuildingHeaderProps> = ({
    building,
    projectTitle,
}) => {
    return (
        <Card className="guest-building-header mb-4">
            <Card.Body>
                <div className="d-flex align-items-start gap-3">
                    <div className="guest-building-header__icon">
                        <Building size={32} />
                    </div>
                    <div className="guest-building-header__content flex-grow-1">
                        <h1 className="guest-building-header__title h4 mb-1">
                            {projectTitle}
                        </h1>
                        <h2 className="guest-building-header__building h6 text-muted mb-2">
                            {building.name}
                        </h2>
                        {(building.street || building.postalCode || building.city) && (
                            <p className="guest-building-header__address mb-0 text-muted d-flex align-items-start gap-1">
                                <MapPin size={14} className="mt-1 flex-shrink-0" />
                                <span>
                                    {building.street && (
                                        <span className="d-block">{building.street}</span>
                                    )}
                                    {(building.postalCode || building.city) && (
                                        <span className="d-block">
                                            {[building.postalCode, building.city].filter(Boolean).join(' ')}
                                        </span>
                                    )}
                                </span>
                            </p>
                        )}
                    </div>
                </div>
                {building.navigationUrl && (
                    <a
                        href={building.navigationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary mt-3 w-100 d-flex align-items-center justify-content-center gap-2"
                    >
                        <Navigation size={18} />
                        Navigera hit
                    </a>
                )}
            </Card.Body>
        </Card>
    );
};

export default GuestBuildingHeader;
